/* Angular Component */
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatSelect, MatSelectChange } from "@angular/material/select";

export interface ExternalMAMMappedOption {
  id: string;
  displayName: string;
}

@Component({
  selector: "external-mam-providers-setup-step-two",
  templateUrl: "./external-mam-providers-setup-step-two.component.html",
  styleUrls: ["./external-mam-providers-setup-step-two.component.scss"],
})
export class ExternalMAMProvidersSetupStepTwoComponent {
  internalMappedFields: { [key: string]: string };
  internalReferenceFields: ExternalMAMMappedOption[] = [];
  specialSplitChars = "#XM#"; // sepecial string to split on. unlikly that a customer with use it.
  showReferenceError = false;

  @Input()
  mappedFields: { [key: string]: string };

  @Input()
  mappedOptions: ExternalMAMMappedOption[];

  @Input()
  referenceFields: string[];

  @Output()
  fieldMappingChange: EventEmitter<{ key: string; value: string }> =
    new EventEmitter();

  @Output()
  referenceFieldsChange: EventEmitter<Array<string>> = new EventEmitter();

  updateFieldMapping(key, event: MatSelectChange) {
    this.fieldMappingChange.emit({ key: key, value: event.value });
  }
  ngOnInit() {
    this.internalMappedFields = { ...this.mappedFields };
    this.mappedOptions.forEach((option) => {
      if (this.referenceFields.includes(option.id)) {
        this.internalReferenceFields.push(option);
      }
    });
  }
  concateRefreneceIdAndVariable(ref: string, id: string) {
    return `${ref}${this.specialSplitChars}${id}`;
  }
  updateReferenceMapping(event: MatSelectChange, element: MatSelect): void {
    const selected = event.value as ExternalMAMMappedOption[];
    const selectedIds = selected.map((x) => x.id);
    const values = (Object.values(this.mappedFields) as string[]).filter(
      (x) => x,
    );
    const used = values.filter((x: string) =>
      x.includes(this.specialSplitChars),
    );
    if (used.length == 0) {
      this.internalReferenceFields = selected;
      this.referenceFieldsChange.emit(selectedIds);
    } else {
      const usedIds = used.map(
        (x: string) => x.split(this.specialSplitChars)[0],
      );
      if (usedIds.filter((x) => !selectedIds.includes(x)).length > 0) {
        // revert
        const filteredOptions = this.mappedOptions.filter((x) =>
          usedIds.includes(x.id),
        );
        filteredOptions.forEach((element) => {
          selected.push(element);
        });
        element.value = Array.from(new Set(selected));
        this.showReferenceError = true;
        element.close();
      } else {
        this.internalReferenceFields = selected;
        this.referenceFieldsChange.emit(selectedIds);
      }
    }
  }
}
